import React from "react";

import {
  NewModal,
  NewModalBody,
  NewModalContent,
  NewModalFooter,
  NewModalHeader,
  NewModalRef,
  NewModalTitle,
} from "../../../components/modal/NewModal/NewModal";

import Button from "../../../components/ButtonComponent";

type ConfirmFaturaDigitalModalProps = {
  isLoading?: boolean;
  onConfirm?: () => void;
};

const ConfirmFaturaDigitalModal = React.forwardRef<NewModalRef, ConfirmFaturaDigitalModalProps>(
  ({ isLoading = false, onConfirm = () => {} }, ref) => {
    return (
      <NewModal ref={ref} className="max-w-[592px]" hideCloseButton={isLoading} isDismissable={false}>
        <NewModalContent>
          <NewModalHeader>
            <NewModalTitle></NewModalTitle>
          </NewModalHeader>
          <NewModalBody>
            <p>
              Ao confirmar, você <strong>concorda em receber a fatura da distribuidora e a fatura da IVI no formato digital</strong>,
              diretamente no <strong>e-mail informado no seu cadastro</strong>.
            </p>
            <p>
              Essa mudança traz mais <strong>praticidade, segurança e contribui para a preservação do meio ambiente</strong>, reduzindo o
              uso de papel.
            </p>
          </NewModalBody>
          <NewModalFooter>
            <Button className="continue-button w-full max-w-[142px]" onClick={() => onConfirm()} isDisabled={isLoading}>
              Confirmar
            </Button>
          </NewModalFooter>
        </NewModalContent>
      </NewModal>
    );
  }
);

export default ConfirmFaturaDigitalModal;
